// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "body {\n  width: 1700px;\n  margin: 0 auto;\n  overflow: auto;\n}", ""]);
// Exports
module.exports = exports;
